import { DB_PREFIX } from './constants';

export default {
  [DB_PREFIX]: {
    isGroup: null,
    users: [],
  },
};
// { firstName: '', lastName: '', phone: '', email: '' }
